import { render, staticRenderFns } from "./Unexcused.vue?vue&type=template&id=1b2f07a8"
import script from "./Unexcused.vue?vue&type=script&lang=js"
export * from "./Unexcused.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports